import React, { useState } from 'react';
import Calendar from '../Calendar.js';
import '../Calendar.css'

function RightContainerEventMlt({ eventDates }) {

    const [date, setDate] = useState(new Date());

    const handleMonthChange = (direction) => {
        const newDate = new Date(date);
        newDate.setMonth(date.getMonth() + direction);
        setDate(newDate);
    };

    const handleYearChange = (direction) => {
        const newDate = new Date(date);
        newDate.setFullYear(date.getFullYear() + direction);
        setDate(newDate);
    };

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];

    return (
        <>
            <div className="rightcontainer mt-4" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100">
                {/* start of calendar */}
                <div className="calendar-header row calenderHeaderRequestor">
                    <div className="col-2 calendar-btn">
                        <button className="calendarbutton btn btn-success" onClick={() => handleMonthChange(-1)}>&lt;</button>
                    </div>
                    <div className="col-2 calendar-text">
                        <h6>{monthNames[date.getMonth()]}</h6>
                    </div>                   
                    <div className="col-2">
                        <button className="calendarbutton btn btn-success" onClick={() => handleMonthChange(1)}>&gt;</button>
                    </div>
                    <div className="col-2">
                        <button className="calendarbutton btn btn-success" onClick={() => handleYearChange(-1)}>&lt;</button>
                    </div>
                    <div className="col-2 calendar-text">
                        <h6>{date.getFullYear()}</h6>
                    </div>
                    <div className="col-2">
                        <button className="calendarbutton btn btn-success" onClick={() => handleYearChange(1)}>&gt;</button>
                    </div>
                </div>
                <Calendar date={date} eventDates={eventDates} />
            </div>
        </>
    );
}

export default RightContainerEventMlt;
